<script setup lang="ts">
import SettingsStoreDetailPageForm from './components/SettingsStoreDetailPageForm.vue'

const route = useRoute()

const selected = ref({
  googlePlaceId: null
})
const store = ref(null)

const storeId = computed(() => Number(route.params.storeId))

watch(store, () => {
  if (store.value?.googlePlaceId) {
    selected.value.googlePlaceId = store.value.googlePlaceId
  }
})
</script>

<template>
  <SettingsStoreDetailPageForm :store-id="storeId" />
</template>
